import { LayoutCommentTypeLookup } from "./LayoutCommentTypeLookup";

export class CommentTypeLookup extends LayoutCommentTypeLookup {
}
